import {get} from "./request"
// 获取学校信息
export const getSchoolInFo = data => get('/getSchoolInFo',data);
// 获取访问量接口
export const statisticalData = data => get('/statisticalData',data);
// 获取首页轮播图
export const getInformationPicList = data => get('/getInformationPicList',data);
// 获取首页块级轮播
export const getInformationPiecePicList = data => get('/getInformationPiecePicList',data);
// 获取资讯
export const getInformationList = data => get('/getInformationList',data);
// 资讯详情
export const getInformationInFo = data => get('/getInformationInFo',data);
// 名师堂
export const getTeacherList = data => get('/getTeacherList',data);
// 名师堂详情
export const getTeacherInFo = data => get('/getTeacherInFo',data);
// 友情链接
export const getBlogrollTree = data => get('/getBlogrollTree',data);
// 资源列表获取资源分类
export const getResourceList = data => get('/getResourceList',data);
// 资源列表获取专业类别
export const getSpecialtyList = data => get('/getSpecialtyList',data);
// 获取资源类型
export const getFileTypeList = data => get('/getFileTypeList',data);
// 获取资源大类
export const getFileCategoryList = data => get('/getFileCategoryList',data);

// 获取手机验证码
export const getCode = data => get('/getCode',data);
// 忘记密码获取验证码
export const retrievePassword = data => get('/retrievePassword',data);
// 忘记密码
export const forgetPassword = data => get('/forgetPassword',data);
// 用户登录
export const studentLogin = data => get('/studentLogin',data);
// 获取个人信息
export const getStudentInFo = data => get('/getStudentInFo',data);
// 退出登录
export const logout = data => get('/logout',data);

// 获取所有课程列表
export const getFileList = data => get('/getFileList',data);
// 获取专业资源页面分类接口
export const getCategoryList = data => get('/getCategoryList',data);
// 首页下载排行
export const getDownRanking = data => get('/getDownRanking',data);
// 获取首页精品资源热门资源
export const getIndexList = data => get('/getIndexList',data);
// 获取资源详情
export const getResourceInFo = data => get('/getResourceInFo',data);
// 获取名师堂教学资源
export const getTeacherFileList = data => get('/getTeacherFileList',data);
// 获取首页资源库占比
export const getSchoolResourceProportion = data => get('/getSchoolResourceProportion',data);
// 浏览文件
export const previewResource = data => get('/previewResource',data);
// 下载文件
export const downloadResource = data => get('/downloadResource',data);
// 获取栏目类型
export const getCplumnList = data => get('/getCplumnList',data);
// 获取页脚信息
export const getWebFooter = data => get('/getWebFooter',data);
// 收藏
export const addCollection = data => get('/addCollection',data);
//取消收藏
export const deleteCollection = data => get('/deleteCollection',data);
//获取收藏列表
export const getCollectionList = data => get('/getCollectionList',data);
//删除收藏
export const deleteCollectionList = data => get('/deleteCollectionList',data);
//获取学校ID
export const getSchoolIdByDomain = data => get('/getSchoolIdByDomain',data);










